import { API, getInviteToken } from "./api";

const pad = (n) => String(n).padStart(2, "0");

// Dates are built in UTC purely as a container for the event's local wall-clock time.
function range(ev) {
  if (!ev.date) return null;
  const [y, m, d] = ev.date.split("-").map(Number);
  if (!ev.time) return { allDay: true, start: new Date(Date.UTC(y, m - 1, d)), end: new Date(Date.UTC(y, m - 1, d + 1)) };
  const [hh, mm] = ev.time.split(":").map(Number);
  const start = new Date(Date.UTC(y, m - 1, d, hh, mm));
  return { allDay: false, start, end: new Date(start.getTime() + 2 * 3600 * 1000) };
}

const ymd = (dt, sep = "") => `${dt.getUTCFullYear()}${sep}${pad(dt.getUTCMonth() + 1)}${sep}${pad(dt.getUTCDate())}`;
const hms = (dt, sep = "") => `${pad(dt.getUTCHours())}${sep}${pad(dt.getUTCMinutes())}${sep}00`;

export function googleCalendarUrl(ev) {
  const r = range(ev);
  if (!r) return null;
  const fmt = (dt) => (r.allDay ? ymd(dt) : `${ymd(dt)}T${hms(dt)}`);
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: ev.occasion,
    dates: `${fmt(r.start)}/${fmt(r.end)}`,
    location: ev.place || "",
    details: ev.sub_header || "",
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

export function outlookCalendarUrl(ev) {
  const r = range(ev);
  if (!r) return null;
  const fmt = (dt) => (r.allDay ? ymd(dt, "-") : `${ymd(dt, "-")}T${hms(dt, ":")}`);
  const params = new URLSearchParams({
    path: "/calendar/action/compose",
    rru: "addevent",
    subject: ev.occasion,
    startdt: fmt(r.start),
    enddt: fmt(r.end),
    location: ev.place || "",
    body: ev.sub_header || "",
    allday: String(r.allDay),
  });
  return `https://outlook.live.com/calendar/0/deeplink/compose?${params.toString()}`;
}

export const icsUrl = (slug) => {
  const token = getInviteToken(slug);
  return `${API}/public/events/${slug}/calendar.ics${token ? `?t=${encodeURIComponent(token)}` : ""}`;
};
